export { default } from './HomeSlider';
